import { useState } from 'react';
import { api, ApiError } from '@/api/client';
import { useLogin } from '@/api/queries';
import { Button } from '@/components/kit/Button';
import { Form, TextField } from '@/components/kit/Field';
import { Note } from '@/components/kit/Note';
import { useToast } from '@/components/kit/Toast';

/**
 * Вход по email и паролю (ТЗ §8).
 *
 * Текст отказа берётся из ответа сервера: он один и тот же
 * для неверного пароля и несуществующего адреса — иначе форма
 * работает списком заведённых пользователей.
 */
export function LoginPage() {
  const login = useLogin();
  const toast = useToast();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [resetSent, setResetSent] = useState(false);

  const submit = () => {
    setError(null);
    login.mutate(
      { email, password },
      { onError: (e) => setError(e instanceof ApiError ? e.message : 'Не удалось войти.') },
    );
  };

  const requestReset = async () => {
    if (!email.trim()) {
      setError('Введите email — на него придёт ссылка.');
      return;
    }
    try {
      await api.post('/auth/password/request-reset', { email });
      setResetSent(true);
    } catch (e) {
      toast.showError(e instanceof ApiError ? e.message : 'Не удалось отправить письмо.');
    }
  };

  return (
    <div className="ui" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
      <div style={{ width: 'min(360px, 100% - 32px)' }}>
        <div className="brand" style={{ padding: 0, marginBottom: 'var(--s7)' }}>
          <div className="bmark">YC</div>
          <div className="bname">YouChamp</div>
        </div>

        <h1 className="h1" style={{ marginBottom: 'var(--s5)' }}>
          Вход
        </h1>

        <Form>
          <TextField
            label="Email"
            type="email"
            autoComplete="username"
            value={email}
            onValue={setEmail}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
          <TextField
            label="Пароль"
            type="password"
            autoComplete="current-password"
            value={password}
            onValue={setPassword}
            error={error}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />

          <div style={{ display: 'flex', gap: 'var(--s2)', alignItems: 'center' }}>
            <Button tone="primary" onClick={submit} disabled={login.isPending}>
              {login.isPending ? 'Проверяем…' : 'Войти'}
            </Button>
            <Button tone="quiet" onClick={requestReset}>
              Забыли пароль?
            </Button>
          </div>
        </Form>

        {resetSent ? (
          <Note>
            Если такой адрес заведён, на него ушло письмо со ссылкой. Ссылка действует час.
          </Note>
        ) : null}
      </div>
    </div>
  );
}
